export default __webpack_public_path__ + "./images/ky.a079c7b8.png";